<template>
  <section>
    <slot name="icon">
      <img
        v-if="pageIcon"
        :src="'/static/images/icons/' + pageIcon + '.png'"
        class="image-icon"
      />
    </slot>
    <DividerSeparator>
      <DecoratedButton
        name="back"
        type="link"
        :route="{ name: pages.PROFILE_HOMEPAGE }"
        class="wide short dark-blue"
        fontSize=".8em"
      >
        BACK
      </DecoratedButton>
    </DividerSeparator>
    <slot name="aboveContent"></slot>
    <grid>
      <grid-item grow="1">
        <SectionWrapper class="whiteframe shadowframe">
          <slot></slot>
        </SectionWrapper>
      </grid-item>
    </grid>
    <slot name="belowContent"></slot>
  </section>
</template>

<script>
export default {
  name: "profile-section-wrapper",
  props: {
    pageIcon: {
      type: String,
      default: ""
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
